import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

import HRPage from "../../../Component/Admin/HRPage";
import { Router } from "../../Handlers/Router";
import MarketerDetails from "../../../Component/Marketer/MarketerDetails";

export class EditMarketerInfoVM extends InterActive{
    private data:{id:string , name:string , email:string|null , dial_code:string , mobile:string , bank_account:string|null  , commission:string } = {id:'' , name:'' , email:'', dial_code:'', mobile:'' , bank_account:'' , commission:''}

    public get Data():{id:string , name:string , email:string|null  , dial_code:string , mobile:string , bank_account:string|null  , commission:string } { return this.data }

    public set Name(value:string){ this.data.name = value; this.update() }
    public set Email(value:string){ this.data.email = value; this.update() }
    public set DialCode(value:string){ this.data.dial_code = value; this.update() }
    public set Mobile(value:string) { this.data.mobile = value; this.update() }
    public set BankAccount(value:string){ this.data.bank_account = GeneralMethods.removeNonAlphanumeric(value); this.update() }
    public set Commission(value:string){ this.data.commission = GeneralMethods.removeNonFloatNumeric(value); this.update() }

    constructor(id:string){
        super()
        this.data.id = id
    }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getMarketerInfo(this.data.id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data.name = response.data.data.name
                                this.data.email = response.data.data.email
                                this.data.bank_account = response.data.data.bank_account
                                this.data.dial_code = response.data.data.dial_code
                                this.data.mobile = response.data.data.mobile
                                this.data.commission = response.data.data.commission
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                     Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    public send(){
        if(this.validation()){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.editMarketerInfo(this.data)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    Notify({type:'success' , title:'تمت العملية بنجاح' , body:'تمت عملية التعديل بنجاح'})
                                    Router.OpenNormalPage(<MarketerDetails id={this.data.id}/>)
                                    this.update()
                                }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                            }else {
                                Notify({type:'danger' , title:'فشل العملية' , body:'فشل عملية التعديل ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                            }
                        }
                    }catch{ Notify({type:'danger' , title:'فشل العملية' , body:'فشل عملية التعديل ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
                }
            )
        }
    }

    private validation(){
        if(!this.data.name){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال اسم المسوق'});  return false; }
        if(this.data.email){
            if(!GeneralMethods.isValidEmail(this.data.email)){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال قيمة صالحة للايميل'});  return false; }
        }
        if(!this.data.commission){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال نسبة العمولة للمسوق'});  return false; }
        else if(!GeneralMethods.isValidFloatNumber(this.data.commission)){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال قيمة صالحة لعمولة المسوق'});  return false; }
        return true;
    }


}